export default {
    app: {
        title: '画面サイズチェッカー',
        subtitle: 'ディスプレイ画面の幅、縦、インチが計測できる便利ツール',
        description: '画面サイズチェッカーはディスプレイ画面の幅、縦、インチが計測できる便利ツールです。',
        width: '幅',
        height: '高さ',
        diagonal: '対角線',
        inches: 'インチ',
        pixels: 'ピクセル',
        screen_size: '画面サイズ',
        resolution: '解像度',
        aspect_ratio: 'アスペクト比',
        pixel_density: 'ピクセル密度',
        ppi: 'PPI（1インチあたりのピクセル数）',
        device_info: 'デバイス情報',
        browser: 'ブラウザ',
        os: 'OS',
        language: '言語',
        home: 'ホーム',
        privacy_policy: 'プライバシーポリシー'
    }
};
